// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as Json_encode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Network$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as SuspensionRepoConfig from "./SuspensionRepoConfig.bs.js";
import * as CommonRepoConfig$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/CommonRepoConfig.bs.js";
import * as PostRequestHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/PostRequestHelper.bs.js";

function fetchSuspensionInfo(driverUuid, country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/suspension/get_suspension_history?driver_uuid=" + driverUuid;
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SuspensionRepoConfig.SuspensionHistoryResponseConverter.execute, result);
                        });
            });
}

function fetchSuspensionReasons(country) {
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/suspension/get_suspension_reasons";
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SuspensionRepoConfig.SuspensionReasonsResponseConverter.execute, result);
                        });
            });
}

function suspendPartner(msisdn, driverUuid, adminId, adminEmail, reason, comment, hours, country) {
  var startTs = Date.now() / 1000.0 | 0;
  var durationObj;
  if (hours !== undefined) {
    var expiryTs = startTs + Math.imul(hours, 3600) | 0;
    durationObj = Json_encode.object_({
          hd: [
            "@type",
            "FIXED_DURATION"
          ],
          tl: {
            hd: [
              "expiry_ts",
              expiryTs
            ],
            tl: /* [] */0
          }
        });
  } else {
    durationObj = Json_encode.object_({
          hd: [
            "@type",
            "INFINITE_DURATION"
          ],
          tl: /* [] */0
        });
  }
  var payloadString = JSON.stringify(Json_encode.object_({
            hd: [
              "driver_uuid",
              driverUuid
            ],
            tl: {
              hd: [
                "suspension_reason",
                reason
              ],
              tl: {
                hd: [
                  "mode",
                  Json_encode.object_({
                        hd: [
                          "@type",
                          "MANUAL_MODE"
                        ],
                        tl: {
                          hd: [
                            "admin_email",
                            adminEmail
                          ],
                          tl: {
                            hd: [
                              "comment",
                              comment
                            ],
                            tl: /* [] */0
                          }
                        }
                      })
                ],
                tl: {
                  hd: [
                    "duration",
                    durationObj
                  ],
                  tl: {
                    hd: [
                      "startTs",
                      startTs
                    ],
                    tl: /* [] */0
                  }
                }
              }
            }
          }));
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/suspension/suspend_driver";
  return Network$Catalyst.postRequestV2(requestUrl, payloadString, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              if (typeof result === "number") {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: /* DefaultError */{
                              _0: {
                                title: /* InternalServerError */3,
                                message: "Suspension failed"
                              }
                            }
                          });
              }
              switch (result.TAG | 0) {
                case /* Success */0 :
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: SuspensionRepoConfig.decodeSuspendResponse(result._0, msisdn)
                              });
                case /* Forbidden */5 :
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: /* DefaultError */{
                                  _0: {
                                    title: /* Forbidden */2,
                                    message: "Action failed - you are not authorized to suspend"
                                  }
                                }
                              });
                default:
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: /* DefaultError */{
                                _0: {
                                  title: /* InternalServerError */3,
                                  message: "Suspension failed"
                                }
                              }
                            });
              }
            });
}

function unsuspendPartner(msisdn, comment, country) {
  var payloadString = PostRequestHelper$Catalyst.getPostRequestPayload({
        hd: {
          name: "msisdn",
          value: msisdn
        },
        tl: {
          hd: {
            name: "unsuspension_comment",
            value: comment
          },
          tl: /* [] */0
        }
      });
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/unsuspend_driver";
  return Network$Catalyst.postRequestV2(requestUrl, payloadString, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CommonRepoConfig$Catalyst.PostApiResponseConverter.execute, result);
                        });
            });
}

function unsuspendPartnerV2(msisdn, driverUuid, adminId, adminEmail, comment, country) {
  var payloadString = JSON.stringify(Json_encode.object_({
            hd: [
              "driver_uuid",
              driverUuid
            ],
            tl: {
              hd: [
                "adminId",
                adminId
              ],
              tl: {
                hd: [
                  "mode",
                  Json_encode.object_({
                        hd: [
                          "@type",
                          "MANUAL_MODE"
                        ],
                        tl: {
                          hd: [
                            "admin_email",
                            adminEmail
                          ],
                          tl: {
                            hd: [
                              "comment",
                              comment
                            ],
                            tl: /* [] */0
                          }
                        }
                      })
                ],
                tl: {
                  hd: [
                    "suspensionHistoryId",
                    null
                  ],
                  tl: /* [] */0
                }
              }
            }
          }));
  var requestUrl = Config.Env.getCrmGatewayUrl(undefined) + "/suspension/un_suspend_driver";
  return Network$Catalyst.postRequestV2(requestUrl, payloadString, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              if (typeof result === "number") {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: /* DefaultError */{
                              _0: {
                                title: /* InternalServerError */3,
                                message: "Unsuspension failed"
                              }
                            }
                          });
              }
              switch (result.TAG | 0) {
                case /* Success */0 :
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: SuspensionRepoConfig.decodeUnsuspendResponse(result._0, msisdn)
                              });
                case /* Forbidden */5 :
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: /* DefaultError */{
                                  _0: {
                                    title: /* Forbidden */2,
                                    message: "Action failed - you are not authorized to unsuspend"
                                  }
                                }
                              });
                default:
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: /* DefaultError */{
                                _0: {
                                  title: /* InternalServerError */3,
                                  message: "Unsuspension failed"
                                }
                              }
                            });
              }
            });
}

var SuspensionRepo = {
  fetchSuspensionInfo: fetchSuspensionInfo,
  fetchSuspensionReasons: fetchSuspensionReasons,
  suspendPartner: suspendPartner,
  unsuspendPartner: unsuspendPartner,
  unsuspendPartnerV2: unsuspendPartnerV2
};

export {
  SuspensionRepo ,
  
}
/* Config Not a pure module */
